<template>
    <div>
        <div class="search-box">
            <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.xn" />
            </a-date-picker>
            <p>学期：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.xq" >
                <!-- For years before 2025, keep all options -->
                <template v-if="year < '2025'">
                    <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                </template>
                <!-- For 2025 and later, only show two semesters -->
                <template v-else>
                    <a-select-option :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                </template>
            </a-select>
            <p>课程名称：</p>
            <a-input class="input-box" v-model="searchFrom.kcmc" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>

        </div>
        <div class="operation-box">
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="remove()">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:culture:pxbsj:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="parallelClass('edit')"
                v-if="permissions.indexOf('undergraduate:culture:pxbsj:edit')>-1">
                 修改
            </a-button>
            <a-button type="primary" class="btn" icon="file-search" @click="parallelClass('look')">查看详情</a-button>
            <a-button 
                type="primary"
                icon="check" 
                class="btn" 
                @click="parallelClass('approve')"
                v-if="permissions.indexOf('undergraduate:culture:pxbsj:approve')>-1">
                 审批
            </a-button>
            <a-button 
                type="primary"
                icon="check" 
                class="btn" 
                @click="showModal"
                v-if="permissions.indexOf('undergraduate:culture:pxbsj:approve')>-1">
                 批量审批
            </a-button>
            <a-button type="primary" class="btn" icon="download" v-if="permissions.indexOf('undergraduate:culture:pxbsj:export')>-1" @click="exportTable">导出Excel</a-button>

        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>
        <div>
            <a-modal v-model="visible" title="审批意见" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleOk('')">
                取消
                </a-button>
                <a-button key="submit" type='danger' :loading="loading" @click="handleOk('reject')">
                驳回
                </a-button>
                <a-button key="submit" type="primary" :loading="loading" @click="handleOk('approved')">
                通过
                </a-button>
            </template>
                <a-textarea
                    class="input-box"
                    v-model="info.spyj"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                />
            </a-modal>
        </div>
    </div>
    
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,batchApprove,exportTable } from '@/baseAPI/undergraduate/culture/parallelClass'
    import { getSchoolYear,getSemester,transformSeason } from '@/baseAPI/util'
    const columns = [
        {
            title: '序号',
            align:'center',
            customRender: (text, row, index) => {
                return { children: index+1+''};
            },
        },
        {
            title: '学年',
            dataIndex: 'schoolYear',
            align:'center',
        },
        {
            title: '学期',
            dataIndex: 'semester',
            align:'center',
            customRender: (text, row, index) => {
                return transformSeason(text)
            },
        },
        {
            title: '课程号',
            dataIndex: 'courseId',
            align:'center',
        },
        {
            title: '课程名',
            dataIndex: 'courseName',
            align:'center',
        },
        {
            title: '学分',
            dataIndex: 'credit',
            align:'center'
        },
        {
            title: '教师姓名',
            dataIndex: 'teacherName',
            align:'center'
        },
        {
            title: '教师编号',
            dataIndex: 'teacherId',
            align:'center'
        },
        {
            title: '教师号',
            dataIndex: 'classId',
            align:'center',
        },
        {
            title: '是否统一试卷',
            dataIndex: 'tysj',
            align:'center',
            customRender: (text, row, index) => {
                return text ? '是':'否';
            }
        },
        {
            title: '状态',
            dataIndex: 'approvalStatus',
            align:'center',
            customRender:(text,row,inde)=>{
                let status
                if(text == 'commit'){
                    status='已提交'
                }else if(text == 'approved'){
                    status='系主任已审核'
                }else if(text == 'reject'){
                    status='已驳回'
                }
                return status
            }
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            align:'center',
        }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    xn:'',
                    xq:'',
                    kmmc:''
                },
                xbArr:[],
                xxArr:[],
                kclbArr:[],
                permissions:[],
                year:'',
                yearShowOne:false,
                loading: false,
                visible: false,
                info:{
                    approvalStatus: '',
	                kcbIds: [],
	                spyj: ''
                },
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'}

            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'CAMPUS',status:true}).then(res=>{
                this.xxArr=res.data.dicts;
            })
            getDicts({dataCode:'KCLB',status:true}).then(res=>{
                this.kclbArr=res.data.dicts;
            })
            this.searchFrom.xn=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            this.searchFrom.xq=getSemester()
            this.fetch()
        },
        methods:{
            exportTable(){
                exportTable(this.searchFrom).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            }, 
            showModal() {
                this.visible = true;
            },
            handleOk(approvalStatus) {
                
                if(approvalStatus!=''){
                    this.loading = true;
                    this.info.approvalStatus=approvalStatus
                    this.info.kcbIds=this.selectedRowKeys
                    batchApprove(this.info).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'平行班考试'+(approvalStatus=='approved'?'审批通过':'驳回成功'),
                            });
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        this.visible = false;
                        this.loading = false;
                    })
                }else{
                    this.visible = false;
                }
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                this.data = []
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    res.data.records.forEach((record) => {
                        this.data.push({
                            classId:record.kcb.classId,
                            schoolYear:record.kcb.schoolYear,semester:record.kcb.semester,id:record.kcb.id,courseId:record.kcb.courseId,courseName:record.kcb.courseName,
                            credit:record.kcb.credit,teacherName:record.kcb.teacherName,teacherId:record.kcb.teacherId,
                            tysj:record.pxbKs.tysj,approvalStatus:record.pxbKs.approvalStatus,createTime:record.pxbKs.createTime})
                    })
                    console.log(this.data)
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(){
                if(this.selectedRowKeys.length==1){
                    del(this.selectedRowKeys[0]).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'删除平行班考试成功',
                            });
                            this.selectedRowKeys = []
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else if(this.selectedRowKeys.length > 1){
                    this.$notification['info']({
                        message: '提示',
                        description:'只能选择一行进行删除',
                    });
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择平行班后再进行删除',
                    });
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                debugger
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.xn=this.year+'-'+(this.year-0+1);
                this.searchFrom.xq='';
                this.yearShowOne = false;
            },
            onSelectChange(id) {
                this.selectedRowKeys = id;
            },
            parallelClass(type){
                if(this.selectedRowKeys.length==1){
                    this.$router.push('/admin/undergraduate/culture/parallelclass/info?source=list&type='+type+'&courseId='+this.selectedRowKeys[0])
                }else if(this.selectedRowKeys.length > 1){
                    this.$notification['info']({
                        message: '提示',
                        description:'只能选择一行',
                    });
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择平行班考试记录',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
